import { AuthorsLoadingSkeleton } from "pages/[tenant]/browse/components/Carousel/components/Authors/LoadingSkeleton";
import { GroupHighlightSectionLoadingSkeleton } from "pages/[tenant]/browse/components/Carousel/components/GroupHighlight/LoadingSkeleton";
import { CarouselLoadingSkeleton } from "pages/[tenant]/browse/components/Carousel/components/LoadingSkeleton";
import { TrailSectionLoadingSkeleton } from "pages/[tenant]/browse/components/Carousel/components/TrailSection/LoadingSkeleton";
import { TrendingGroupsLoadingSkeleton } from "pages/[tenant]/browse/components/TrendingGroups/LoadingSkeleton";
import { TrendingLessonsLoadingSkeleton } from "pages/[tenant]/browse/components/TrendingLessons/LoadingSkeleton";
import { ISectionContent } from "pages/[tenant]/browse/types";

import { IBillboardSection } from "shared/types/billboard";

interface IGetDownContentLoadingSkeletonProps {
  sectionContent: ISectionContent[][];
  section: IBillboardSection;
  index: number;
}

export const getDownContentLoadingSkeleton = ({
  section,
  sectionContent,
  index,
}: IGetDownContentLoadingSkeletonProps) => {
  const contentLength = sectionContent?.[index]?.length;
  const orientation = section?.prefer_vertical_logo ? "vertical" : "horizontal";
  const contentIsTrail =
    section?.type === "trail" && !!section?.relation?.short_description;
  const contentIsGroupHiglight = section?.type === "group_highlight";
  const contentIsAuthors = section?.type === "authors";
  const sectionMostVisitedGroups = section?.type === "most_visited_groups";
  const sectionMostVisitedlessons = section?.type === "most_visited_lessons";

  return contentIsTrail ? (
    <TrailSectionLoadingSkeleton
      contentLength={contentLength}
      orientation={orientation}
    />
  ) : sectionMostVisitedGroups ? (
    <TrendingGroupsLoadingSkeleton contentLength={contentLength} />
  ) : sectionMostVisitedlessons ? (
    <TrendingLessonsLoadingSkeleton contentLength={contentLength} />
  ) : contentIsGroupHiglight ? (
    <GroupHighlightSectionLoadingSkeleton contentLength={contentLength} />
  ) : contentIsAuthors ? (
    <AuthorsLoadingSkeleton contentLength={contentLength} />
  ) : (
    <CarouselLoadingSkeleton
      contentLength={contentLength}
      orientation={orientation}
    />
  );
};
